/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Jump_LabelInputs */

const en_services_jump_label = /** @type {(inputs: Services_Jump_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service categories`)
};

const lv_services_jump_label = /** @type {(inputs: Services_Jump_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakalpojumu kategorijas`)
};

/**
* | output |
* | --- |
* | "Service categories" |
*
* @param {Services_Jump_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_jump_label = /** @type {((inputs?: Services_Jump_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Jump_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_jump_label(inputs)
	return en_services_jump_label(inputs)
});